// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Auth {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.register{
  max-width: 978px;
  width: 100vw;
  display:flex;
  border: 1px solid #e9ecef;
  border-radius: 5px;
  /* box-shadow: 1px 3px 10px #e9ecef; */
  background-color: white;
}

.register span{
  color: #adb5bd;
}

.formulaire .contenu{
  max-width: 320px;
  width: 100vw;
  margin: 2em auto;
}

#form >  input, .bouton{
  border: 1px solid #e9ecef;
  padding: .9em 1em;
}

#form > input:focus{
  outline: none;
}

.bouton{
  background-color: #2b2b81;
  color: #e9ecef;
  font-size: 1em;
  cursor: pointer;
  border-radius: 10px;
}

.bouton:hover{
  background-color: #bf9e1d;
}

.formulaire{
  display: flex;
  gap: 1em;
}

.contenu{
  flex-direction: column;
}

.register .register-container{
  margin: auto;
  padding: 3em 0;
}

.register .picture img{
  width: 480px;
  height: 100%;
  object-fit: cover;
  align-self: flex-end;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  display: none;
}

@media screen and (min-width: 860px)  {
  .register .picture img{
    display: initial;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Auth/Login/login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,4BAA4B;EAC5B,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".Auth {\n  height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n\n.register{\n  max-width: 978px;\n  width: 100vw;\n  display:flex;\n  border: 1px solid #e9ecef;\n  border-radius: 5px;\n  /* box-shadow: 1px 3px 10px #e9ecef; */\n  background-color: white;\n}\n\n.register span{\n  color: #adb5bd;\n}\n\n.formulaire .contenu{\n  max-width: 320px;\n  width: 100vw;\n  margin: 2em auto;\n}\n\n#form >  input, .bouton{\n  border: 1px solid #e9ecef;\n  padding: .9em 1em;\n}\n\n#form > input:focus{\n  outline: none;\n}\n\n.bouton{\n  background-color: #2b2b81;\n  color: #e9ecef;\n  font-size: 1em;\n  cursor: pointer;\n  border-radius: 10px;\n}\n\n.bouton:hover{\n  background-color: #bf9e1d;\n}\n\n.formulaire{\n  display: flex;\n  gap: 1em;\n}\n\n.contenu{\n  flex-direction: column;\n}\n\n.register .register-container{\n  margin: auto;\n  padding: 3em 0;\n}\n\n.register .picture img{\n  width: 480px;\n  height: 100%;\n  object-fit: cover;\n  align-self: flex-end;\n  border-top-right-radius: 5px;\n  border-bottom-right-radius: 5px;\n  display: none;\n}\n\n@media screen and (min-width: 860px)  {\n  .register .picture img{\n    display: initial;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
